import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.687 6.315s.91 2.556 2.02 3.666 3.666 2.02 3.666 2.02-2.556.91-3.666 2.02c-1.11 1.111-2.02 3.667-2.02 3.667s-.91-2.556-2.02-3.666C5.555 12.912 3 12.002 3 12.002s2.556-.91 3.666-2.02c1.11-1.111 2.02-3.667 2.02-3.667ZM17.5 14s.56 1.573 1.244 2.256C19.427 16.94 21 17.5 21 17.5s-1.573.56-2.256 1.244C18.06 19.427 17.5 21 17.5 21s-.56-1.573-1.244-2.256C15.574 18.06 14 17.5 14 17.5s1.573-.56 2.256-1.244C16.94 15.574 17.5 14 17.5 14ZM17.5 3s.56 1.573 1.244 2.256C19.427 5.94 21 6.5 21 6.5s-1.573.56-2.256 1.244C18.06 8.427 17.5 10 17.5 10s-.56-1.573-1.244-2.256C15.574 7.06 14 6.5 14 6.5s1.573-.56 2.256-1.244C16.94 4.573 17.5 3 17.5 3Z"
    }, null, -1)
  ]))]))
}
export default { render: render }